import JupiterHeroSection from "./components/HeroSection";
import JupiterStickyNav from "./components/StickyNav";
import JupiterProcessingTimeSection from "./components/ProcessingTimeSection";
import JupiterServicesSection from "./components/ServicesSection";
import JupiterLocalAreaSection from "./components/LocalAreaSection";
import JupiterTravelTimingSection from "./components/TravelTimingSection";
import JupiterDestinationsSection from "./components/DestinationsSection";
import JupiterTestimonialsSection from "./components/TestimonialsSection";
import JupiterAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JupiterComparisonSection from "./components/ComparisonSection";
import JupiterMistakesSection from "./components/MistakesSection";
import JupiterHowItWorksSection from "./components/HowItWorksSection";
import JupiterFAQSection, { faqs } from "./components/FAQSection";
import JupiterHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JupiterFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function JupiterPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Jupiter"
        state="Florida"
        stateAbbr="FL"
        route="/jupiter"
        title="Emergency Passport Jupiter, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Jupiter, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Jupiter and northern Palm Beach County travelers."
        geoPlacename="Jupiter, Florida"
        geoPosition="26.9342;-80.0942"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
      />
      <JupiterHeroSection />
      <JupiterStickyNav />
      <JupiterProcessingTimeSection />
      <JupiterServicesSection />
      <JupiterLocalAreaSection />
      <JupiterTravelTimingSection />
      <JupiterDestinationsSection />
      <JupiterTestimonialsSection />
      <JupiterAcceptanceFacilitiesSection />
      <JupiterComparisonSection />
      <JupiterMistakesSection />
      <JupiterHowItWorksSection />
      <JupiterFAQSection />
      <JupiterHelpfulResourcesSection />
      <JupiterFinalCTA />
    </div>
  );
}